"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateGamepad = exports.isAxisInDeadzone = exports.getInput = exports.getNullInput = exports.InputState = exports.axisDeadzoneTolerance = exports.maxGamepads = void 0;
var logger_1 = require("@engine/logger");
var assert_sidecar_1 = require("@lib/assert-sidecar");
var common_sidecar_1 = require("@main/common-sidecar");
exports.maxGamepads = 8;
exports.axisDeadzoneTolerance = 0.125; // > 1 for old xbox 360 //0.075 // 0.1
var logger = logger_1.createLogger('minigolf-gamepad');
var verbose_debug = false;
var verbose_debugAxis = false;
var verbose_debugButtons = false;
var InputState;
(function (InputState) {
    InputState[InputState["JustUp"] = 0] = "JustUp";
    InputState[InputState["JustDown"] = 1] = "JustDown";
    InputState[InputState["StaleUp"] = 2] = "StaleUp";
    InputState[InputState["StaleDown"] = 3] = "StaleDown";
})(InputState = exports.InputState || (exports.InputState = {}));
var _input = [];
var getNullInput = function () {
    return {
        left: InputState.StaleUp,
        right: InputState.StaleUp,
        up: InputState.StaleUp,
        down: InputState.StaleUp,
        a: InputState.StaleUp,
        b: InputState.StaleUp,
        x: InputState.StaleUp,
        y: InputState.StaleUp,
        bumperLeft: InputState.StaleUp,
        bumperRight: InputState.StaleUp,
        triggerLeft: InputState.StaleUp,
        triggerRight: InputState.StaleUp,
        axis1X: 0,
        axis1Y: 0,
        axis2X: 0,
        axis2Y: 0,
    };
};
exports.getNullInput = getNullInput;
var getInput = function (num) {
    if (num <= 0) {
        // console.log('getting gamepad 0 or less', num)
        return exports.getNullInput();
        //   // assert.failed('num must be > 0', 'getInput', num)
    }
    num = num - 1;
    if (!_input[num]) {
        _input[num] = {
            left: InputState.StaleUp,
            right: InputState.StaleUp,
            up: InputState.StaleUp,
            down: InputState.StaleUp,
            a: InputState.StaleUp,
            b: InputState.StaleUp,
            x: InputState.StaleUp,
            y: InputState.StaleUp,
            bumperLeft: InputState.StaleUp,
            bumperRight: InputState.StaleUp,
            triggerLeft: InputState.StaleUp,
            triggerRight: InputState.StaleUp,
            axis1X: 0,
            axis1Y: 0,
            axis2X: 0,
            axis2Y: 0,
        };
    }
    var input = _input[num];
    assert_sidecar_1.assert.notNil(input);
    return input;
};
exports.getInput = getInput;
var isAxisInDeadzone = function (x, y) {
    return (
    // Math.abs(x) < axisDeadzoneTolerance && Math.abs(y) < axisDeadzoneTolerance
    x === 0 && y === 0);
};
exports.isAxisInDeadzone = isAxisInDeadzone;
var updateGamepad = function () {
    var s = common_sidecar_1.common.getPhaserScene();
    var phaserInput = s.input;
    if (phaserInput.gamepad.total === 0) {
        return;
    }
    var debug = [];
    var pads = phaserInput.gamepad.gamepads;
    var _loop_1 = function () {
        var gamepadNum = idxGamepad + 1;
        pad = pads[idxGamepad];
        if (!pad) {
            return "continue";
        }
        //  Timestamp, index. ID
        debug.push(pad.id);
        debug.push('Index: ' + pad.index + ' Timestamp: ' + pad.timestamp);
        var updateKey = function (buttonIdx, name) {
            var curState = exports.getInput(gamepadNum)[name];
            var isPressed = false;
            if (pad.buttons[buttonIdx] && pad.buttons[buttonIdx].value > 0.25) {
                isPressed = true;
            }
            var nextState = InputState.StaleUp;
            if (isPressed) {
                if (curState !== InputState.JustDown &&
                    curState !== InputState.StaleDown) {
                    logger.log('pressed', name);
                    nextState = InputState.JustDown;
                }
                else {
                    nextState = InputState.StaleDown;
                }
            }
            else {
                if (curState !== InputState.JustUp && curState !== InputState.StaleUp) {
                    nextState = InputState.JustUp;
                }
                else {
                    nextState = InputState.StaleUp;
                }
            }
            exports.getInput(gamepadNum)[name] = nextState;
        };
        updateKey(12, 'up');
        updateKey(13, 'down');
        updateKey(14, 'left');
        updateKey(15, 'right');
        updateKey(0, 'a');
        updateKey(1, 'b');
        updateKey(2, 'x');
        updateKey(3, 'y');
        updateKey(4, 'bumperLeft');
        updateKey(5, 'bumperRight');
        updateKey(6, 'triggerLeft');
        updateKey(7, 'triggerRight');
        var input = exports.getInput(gamepadNum);
        // const processMove = (key: keyof IInput, move: EInputCommand) => {
        //   if (input[key] === InputState.JustDown) {
        //     rogueCursor.setInputGamepad()
        //     rogueInput.setNextInputCommandAndRun(move)
        //   }
        //   if (input[key] === InputState.JustUp) {
        //     rogueCursor.setInputGamepad()
        //     rogueRunMode.cancelRunMode()
        //   }
        // }
        // processMove('up', rogueInput.EInputCommand.moveUp)
        // processMove('down', rogueInput.EInputCommand.moveDown)
        // processMove('left', rogueInput.EInputCommand.moveLeft)
        // processMove('right', rogueInput.EInputCommand.moveRight)
        // processMove('y', rogueInput.EInputCommand.moveWait)
        //processMove('bumperLeft', rogueInput.EInputCommand.moveWait)
        // processMove('bumperLeft', rogueInput.EInputCommand.menuPrev)
        // processMove('bumperRight', rogueInput.EInputCommand.menuNext)
        // if (input.triggerLeft === InputState.JustDown) {
        //   rogueCursor.setInputGamepad()
        //   rogueInput.setNextInputCommand(rogueInput.EInputCommand.openThrowMenu)
        // }
        // if (input.triggerRight === InputState.JustDown) {
        //   rogueCursor.setInputGamepad()
        //   rogueInput.setNextInputCommand(rogueInput.EInputCommand.openFireMenu)
        // }
        // if (input.bumperLeft === InputState.JustDown) {
        //   rogueCursor.setInputGamepad()
        //   // rogueInput.setNextInputCommand(rogueInput.EInputCommand.openInventory)
        //   rogueInput.setNextInputCommand(rogueInput.EInputCommand.menuPrev)
        // }
        // if (input.bumperRight === InputState.JustDown) {
        //   rogueCursor.setInputGamepad()
        //   rogueInput.setNextInputCommand(rogueInput.EInputCommand.menuNext)
        //   // rogueInput.setNextInputCommand(rogueInput.EInputCommand.openCastMenu)
        // }
        // if (input.a === InputState.JustDown) {
        //   rogueCursor.setInputGamepad()
        //   rogueInput.setNextInputCommand(rogueInput.EInputCommand.select)
        // }
        // if (input.b === InputState.JustDown) {
        //   rogueCursor.setInputGamepad()
        //   rogueInput.setNextInputCommand(rogueInput.EInputCommand.cancel)
        // }
        // if (input.y === InputState.JustDown) {
        //   rogueCursor.setInputGamepad()
        //   rogueInput.setNextInputCommand(rogueInput.EInputCommand.moveWait)
        //   //rogueInput.setNextInputCommand(rogueInput.EInputCommand.openCastMenu)
        // }
        if (input.x === InputState.JustDown) {
            // rogueCursor.setInputGamepad()
            // // rogueInput.setNextInputCommand(rogueInput.EInputCommand.openContextMenu)
            // rogueInput.setNextInputCommand(rogueInput.EInputCommand.swapWeapons)
        }
        axes = '';
        var adjustAxisWithDeadzone = function (axis) {
            if (Math.abs(axis) < exports.axisDeadzoneTolerance) {
                return 0;
            }
            if (axis < 0) {
                axis = axis + exports.axisDeadzoneTolerance;
            }
            else {
                axis = axis - exports.axisDeadzoneTolerance;
            }
            // Normalize to 1
            axis = axis / (1 - exports.axisDeadzoneTolerance);
            return axis;
        };
        for (var a = 0; a < pad.axes.length; a++) {
            axis = pad.axes[a];
            axisValue = adjustAxisWithDeadzone(axis.value);
            var input_1 = exports.getInput(gamepadNum);
            if (a === 0) {
                input_1.axis1X = axisValue; //adjustAxisWithDeadzone(axis.value)
            }
            if (a === 1) {
                input_1.axis1Y = axisValue; //adjustAxisWithDeadzone(axis.value)
            }
            if (a === 2) {
                input_1.axis2X = axisValue; //adjustAxisWithDeadzone(axis.value)
            }
            if (a === 3) {
                input_1.axis2Y = axisValue; //adjustAxisWithDeadzone(axis.value)
            }
            if (axisValue != 0.0) {
                axes +=
                    +gamepadNum +
                        'A' +
                        axis.index +
                        ': ' +
                        axis.getValue() +
                        '  ' +
                        axisValue;
                if (verbose_debug) {
                    console.log(gamepadNum +
                        'A' +
                        axis.index +
                        ': ' +
                        axis.getValue() +
                        '  ' +
                        axisValue);
                }
            }
            // axes = axes.concat('A' + a + ': ' + axis + '  ');
            // if (a === 1) {
            //   debug.push(axes)
            //   axes = ''
            // }
        }
        if (axes) {
            if (verbose_debugAxis) {
                logger.log('axes', axes);
            }
        }
        //  Buttons
        // var buttons = ''
        for (var b = 0; b < pad.buttons.length; b++) {
            button = pad.buttons[b];
            if (button.value > 0.05) {
                if (verbose_debugButtons) {
                    logger.log('button', b, button.value);
                }
            }
            // if (b === 12) {
            //   rogueInput.setNextInputCommand(rogueInput.EInputCommand.moveUp)
            // }
            // if (b === 13) {
            //   rogueInput.setNextInputCommand(rogueInput.EInputCommand.moveDown)
            // }
            // if (b === 14) {
            //   rogueInput.setNextInputCommand(rogueInput.EInputCommand.moveLeft)
            // }
            // if (b === 15) {
            //   rogueInput.setNextInputCommand(rogueInput.EInputCommand.moveRight)
            // }
            // if (b === 0) {
            //   rogueInput.setNextInputCommand(rogueInput.EInputCommand.select)
            // }
            // if (b === 1) {
            //   rogueInput.setNextInputCommand(rogueInput.EInputCommand.closeMenu)
            // }
            // if (b === 3) {
            //   rogueInput.setNextInputCommand(
            //     rogueInput.EInputCommand.openRogueInventory,
            //   )
            // }
            // buttons = buttons.concat('B' + button.index + ': ' + button.value + '  ')
            // // buttons = buttons.concat('B' + b + ': ' + button.value + '  ');
            // if (b === 8) {
            //   debug.push(buttons)
            //   buttons = ''
            // }
        }
    };
    var pad, axes, axis, axisValue, button;
    // console.log('# gamepads ' + pads.length)
    for (var idxGamepad = 0; idxGamepad < pads.length; idxGamepad++) {
        _loop_1();
    }
};
exports.updateGamepad = updateGamepad;
